import { motion } from "framer-motion";
import logo from "@/assets/gekkins_v4.png";

function Loader() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        scale: 0.92,
        y: -8,
        transition: {
          type: "spring",
          stiffness: 700,
          damping: 20,
        },
      }}
      className="fixed inset-0 z-50 flex items-center justify-center scale-85"
    >
      <motion.img
        src={logo}
        alt="logo"
        initial={{ scale: 0.5, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{
          scale: 1.08,
          opacity: 0,
          y: -18,
          transition: {
            type: "spring",
            stiffness: 900,
            damping: 18,
          },
        }}
        transition={{
          type: "spring",
          stiffness: 700,
          damping: 18,
        }}
        className="h-20 lg:h-28 mr-1 mb-3"
      />

      <motion.h1
        initial={{ scale: 0.5, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{
          scale: 1.08,
          opacity: 0,
          y: -18,
          transition: {
            type: "spring",
            stiffness: 900,
            damping: 18,
            delay: 0.03,
          },
        }}
        transition={{
          type: "spring",
          stiffness: 700,
          damping: 18,
          delay: 0.09,
        }}
      >
        Gekkins
      </motion.h1>
    </motion.div>
  );
}

export default Loader;
